import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './shared/services/apis/usuario-admin/auth.service';
import { UsuarioAdminLoginResponse } from './shared/services/responses/usuario-admin/usuario-admin-login.response';
import { PermissaoEnum } from './shared/enums/permissao.enum';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      return false;
    }

    const token: UsuarioAdminLoginResponse = this.authService.getUserInfos();

    if (token.master) return true;

    const modulo: number = route.data['modulo'];
    if (modulo) {
      const temAcessoModulo = token.listaModulos?.some(m => m.idModulo === modulo);
      if (!temAcessoModulo) {
        this.router.navigate(['/home']);
        return false;
      }
    }

    const permissoes: number[] = route.data['permissoes'] || [];
    if (permissoes.length > 0) {
      const temAlgumaPermissao = permissoes.some(p => token.listaPermissoes.includes(p));
      if (!temAlgumaPermissao) {
        this.router.navigate(['/home']);
        return false;
      }

      const idPermissaoIncluir = this.verificaIncluirOuAlterar(permissoes, true);
      const idPermissaoAlterar = this.verificaIncluirOuAlterar(permissoes, false);

      const possuiIncluir = !!idPermissaoIncluir && token.listaPermissoes.includes(idPermissaoIncluir);
      const possuiAlterar = !!idPermissaoAlterar && token.listaPermissoes.includes(idPermissaoAlterar);

      const acessandoCadastro = state.url.includes('/cadastrar');
      const temIdNaRota = route.paramMap.keys.length > 0 || route.queryParamMap.keys.length > 0;

      if (acessandoCadastro && temIdNaRota && !possuiAlterar) {
        this.router.navigate(['/home']);
        return false;
      }

      if (acessandoCadastro && !temIdNaRota && !possuiIncluir) {
        this.router.navigate(['/home']);
        return false;
      }
    }

    return true;
  }

  verificaIncluirOuAlterar(listaPermissao: number[], incluir: boolean): number | undefined {
    const suffix = incluir ? '_Incluir' : '_Alterar';

    for (const [key, value] of Object.entries(PermissaoEnum)) {
      if (typeof value !== 'number') {
        continue;
      }
      if (!key.endsWith(suffix)) {
        continue;
      }
      if (listaPermissao.includes(value)) {
        return value;
      }
    }

    return undefined;
  }
}
